import React, { useState } from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { ProgramTable } from '../components/programs/ProgramTable';
import { CtaBand } from '../components/ui/CtaBand';
import { programs } from '../data/programs';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
const categories = ['All', 'Hormone', 'Metabolic', 'Longevity', 'Everyday'] as const;
export function Programs() {
  const [active, setActive] = useState<(typeof categories)[number]>('All');
  const {
    brand,
    text
  } = useBrand();
  useDocumentMeta({
    title: `Programs — ${brand.name}`,
    description: text('Hormone, metabolic, longevity and everyday care. Every Republic program starts with lab work and a protocol you approve.')
  });
  const visible = active === 'All' ? programs : programs.filter(program => program.category === active);
  return <main data-id="element-590" data-mp="epcwusvu327c">
      <PageHeader eyebrow="Programs" title="Care organised around what you are treating." intro="Every Republic program begins with lab work and ends with a protocol you approved. Medication comes from US-licensed pharmacies, named on your documentation." data-id="element-591" data-mp="eq4hj8nw7fiu" />

      <section className="bg-cream" data-id="element-592" data-mp="19pv1pahs6wo1">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-10 md:px-8 md:pb-28" data-id="element-593" data-mp="19qwg9oy0a1ai">
          <div className="flex flex-wrap gap-2" role="tablist" aria-label="Filter programs by category" data-id="element-594" data-mp="14x1u8euxha89">
            {categories.map(category => <button key={category} type="button" role="tab" aria-selected={active === category} onClick={() => setActive(category)} className={`rounded-brand px-5 py-2.5 text-sm transition-colors duration-150 ease-republic ${active === category ? 'bg-ink text-cream-light' : 'border border-ink/20 text-ink-soft hover:border-ink hover:text-ink'}`} data-id="element-595" data-mp="1enwh9lg00dur">
                {category}
              </button>)}
          </div>

          <ProgramTable items={visible} data-id="element-596" data-mp="1ye0i3t21jd2g" />

          {visible.length === 0 && <p className="rule mt-10 pt-10 text-base text-ink-soft" data-id="element-597" data-mp="22cg5hy21ange">
              No programs in this category yet. Message the care team and we will tell you what is
              coming.
            </p>}
        </div>
      </section>

      <CtaBand title="Not sure which program fits?" intro="Start the intake and a clinician will tell you which program — if any — is clinically appropriate before you pay anything." data-id="element-598" data-mp="2hai5xzdrqstf" />
    </main>;
}